module.exports = __webpack_public_path__ + "static/media/Metrix.c860f68d.m4v";